type OrderableDocument = { id: string }

export function orderDocumentsById<T extends OrderableDocument>(
  documents: T[],
  orderedIds: string[],
  options?: { filterToOrderedIds?: boolean }
): T[] {
  const orderMap = new Map(orderedIds.map((id, i) => [id, i]))
  const rows = options?.filterToOrderedIds
    ? documents.filter((doc) => orderMap.has(doc.id))
    : documents
  return [...rows].sort(
    (a, b) => (orderMap.get(a.id) ?? 0) - (orderMap.get(b.id) ?? 0)
  )
}

export function orderDocumentsByScoreDesc<T extends OrderableDocument>(
  documents: T[],
  scoresByDocumentId: Map<string, number>
): T[] {
  return documents
    .filter((doc) => scoresByDocumentId.has(doc.id))
    .sort(
      (a, b) =>
        (scoresByDocumentId.get(b.id) ?? 0) -
        (scoresByDocumentId.get(a.id) ?? 0)
    )
}
